const SwitchInput = (props) => {
  return (
    <div
      className={`flex 780:flex-row 780:items-center 780:justify-between flex-col items-start gap-2 w-full ${props.disableBorder ? "" : "border-b-2 border-b-stone-400 pb-5"} py-2 mb-4`}
    >
      {props.name && <span className="text-sm">{props.name}</span>}
      <div
        className={`w-[100px] h-[38px] ${props.checked === props.options[0].id ? "bg-main-color-1" : "bg-[#DBDBDB]"} transition-colors duration-300 rounded-full flex items-center cursor-pointer relative overflow-hidden self-end`}
        onClick={() => {
          props.checked === props.options[0].id
            ? props.selectChangeHandler(props.options[1].id)
            : props.selectChangeHandler(props.options[0].id);
        }}
      >
        <div
          className={`absolute transition-all duration-300 ${props.checked === props.options[0].id ? "right-[4px]" : "right-[-58px] top-[4px]"} flex w-[200px] items-center gap-x-[4px]`}
        >
          <span className="w-[58px] text-center text-[14px] text-white-1 font-medium">
            {props.options[0].name}
          </span>
          <div className={`w-[30px] h-[30px] bg-white rounded-full `}></div>
          <span className="w-[58px] text-center text-[14px] text-text-1 font-medium">
            {props.options[1].name}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SwitchInput;
